import { render, staticRenderFns } from "./SendMessageGroupSelectModal.vue?vue&type=template&id=3f2a097e&lang=pug"
import script from "./SendMessageGroupSelectModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupSelectModal.vue?vue&type=style&index=0&id=3f2a097e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports